import {dhx4} from './dhx';

if (typeof dhx4.dateLang == "undefined") {
    dhx4.dateLang = "en";
    dhx4.dateStrings = {
        en: {
            monthFullName: [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ],
            monthShortName: [
                "Jan",
                "Feb",
                "Mar",
                "Apr",
                "May",
                "Jun",
                "Jul",
                "Aug",
                "Sep",
                "Oct",
                "Nov",
                "Dec"
            ],
            dayFullName: [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ],
            dayShortName: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"]
        }
    };
    dhx4.dateFormat = { en: "%Y-%m-%d" };
    //将日期格式转换成字符串
    dhx4.date2str = function (l, g, a) {
        if (g == null || typeof g == "undefined") {
            g = dhx4.dateFormat[dhx4.dateLang];
        }
        if (a == null || typeof a == "undefined") {
            a = dhx4.dateStrings[dhx4.dateLang];
        }
        if (l instanceof Date) {
            var h = function (m) {
                return String(m).length == 1 ? "0" + String(m) : m;
            };
            var c = function (o) {
                switch (o) {
                    case "%d":
                        return h(l.getDate());
                    case "%j":
                        return l.getDate();
                    case "%D":
                        return a.dayShortName[l.getDay()];
                    case "%l":
                        return a.dayFullName[l.getDay()];
                    case "%m":
                        return h(l.getMonth() + 1);
                    case "%n":
                        return l.getMonth() + 1;
                    case "%M":
                        return a.monthShortName[l.getMonth()];
                    case "%F":
                        return a.monthFullName[l.getMonth()];
                    case "%y":
                       
                        return h(l.getYear() % 100);
                    case "%Y":
                        return l.getFullYear();
                    case "%g":
                        return ((l.getHours() + 11) % 12) + 1;
                    case "%h":
                        return h(((l.getHours() + 11) % 12) + 1);
                    case "%G":
                        return l.getHours();
                    case "%H":
                        return h(l.getHours());
                    case "%i":
                        return h(l.getMinutes());
                    case "%s":
                        return h(l.getSeconds());
                    case "%a":
                        return l.getHours() > 11 ? "pm" : "am";
                    case "%A":
                        return l.getHours() > 11 ? "PM" : "AM";
                    case "%%":
                        return "%";
                    case "%u":
                        return l.getMilliseconds();
                    case "%P":
                        if (dhx4.temp_calendar != null && dhx4.temp_calendar.tz != null) {
                            return dhx4.temp_calendar.tz;
                        }
                        var s = l.getTimezoneOffset();
                        var r = Math.abs(Math.floor(s / 60));
                        var n = Math.abs(s) - r * 60;
                        return (s > 0 ? "-" : "+") + h(r) + ":" + h(n);
                    default:
                        return o;
                }
            };
            var e = null;
            e = String(g || dhx4.dateFormat).replace(/%[a-zA-Z]/g, c);
        }
        return e || String(l);
    };
    dhx4.str2date = function (l, A, E) {
        if (A == null || typeof A == "undefined") {
            A = dhx4.dateFormat[dhx4.dateLang];
        }
        if (E == null || typeof E == "undefined") {
            E = dhx4.dateStrings[dhx4.dateLang];
        }
        A = A.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\\:|]/g, "\\$&");
        var D = [];
        var o = [];
        A = A.replace(/%[a-z]/gi, function (e) {
            switch (e) {
                case "%d":
                case "%m":
                case "%y":
                case "%h":
                case "%H":
                case "%i":
                case "%s":
                    o.push(e);
                    return "(\\d{2})";
                case "%D":
                case "%l":
                case "%M":
                case "%F":
                    o.push(e);
                    return "([a-zéûä\u0430-\u044F\u0451]{1,})";
                case "%j":
                case "%n":
                case "%g":
                case "%G":
                    o.push(e);
                    return "(\\d{1,2})";
                case "%Y":
                    o.push(e);
                    return "(\\d{4})";
                case "%a":
                    o.push(e);
                    return "([a|p]m)";
                case "%A":
                    o.push(e);
                    return "([A|P]M)";
                case "%u":
                    o.push(e);
                    return "(\\d{1,6})";
                case "%P":
                    o.push(e);
                    return "([+-]\\d{1,2}:\\d{1,2})";
            }
            return e;
        });
        var F = new RegExp(A, "i");
        var s = l.match(F);
        if (s == null || s.length - 1 != o.length) {
            return "Invalid Date";
        }
        for (var c = 1; c < s.length; c++) {
            D.push(s[c]);
        }
        var g = {
            "%y": 1,
            "%Y": 1,
            "%n": 2,
            "%m": 2,
            "%M": 2,
            "%F": 2,
            "%d": 3,
            "%j": 3,
            "%a": 4,
            "%A": 4,
            "%H": 5,
            "%G": 5,
            "%h": 5,
            "%g": 5,
            "%i": 6,
            "%s": 7,
            "%u": 7,
            "%P": 7
        };
        var u = {};
        var n = {};
        for (var c_1 = 0; c_1 < o.length; c_1++) {
            if (typeof g[o[c_1]] != "undefined") {
                var h = g[o[c_1]];
                if (!u[h]) {
                    u[h] = [];
                    n[h] = [];
                }
                u[h].push(D[c_1]);
                n[h].push(o[c_1]);
            }
        }
        D = [];
        o = [];
        for (var c_2 = 1; c_2 <= 7; c_2++) {
            if (u[c_2] != null) {
                for (var y = 0; y < u[c_2].length; y++) {
                    D.push(u[c_2][y]);
                    o.push(n[c_2][y]);
                }
            }
        }
        var a = new Date();
        a.setDate(1);
        a.setHours(0);
        a.setMinutes(0);
        a.setSeconds(0);
        a.setMilliseconds(0);
        var x = function (v, e) {
            for (var r = 0; r < e.length; r++) {
                if (e[r].toLowerCase() == v) {
                    return r;
                }
            }
            return -1;
        };
        for (var c_3 = 0; c_3 < D.length; c_3++) {
            switch (o[c_3]) {
                case "%d":
                case "%j":
                case "%n":
                case "%m":
                case "%Y":
                case "%H":
                case "%G":
                case "%i":
                case "%s":
                case "%u":
                    if (!isNaN(D[c_3])) {
                        var mMap = {
                            "%d": "setDate",
                            "%j": "setDate",
                            "%n": "setMonth",
                            "%m": "setMonth",
                            "%Y": "setFullYear",
                            "%H": "setHours",
                            "%G": "setHours",
                            "%i": "setMinutes",
                            "%s": "setSeconds",
                            "%u": "setMilliseconds"
                        };
                        a[mMap[o[c_3]]](Number(D[c_3]) + (o[c_3] == "%m" || o[c_3] == "%n" ? -1 : 0));
                    }
                    break;
                case "%M":
                case "%F":
                    var map = { "%M": "monthShortName", "%F": "monthFullName" };
                    var m = x(D[c_3].toLowerCase(), E[map[o[c_3]]]);
                    if (m >= 0) {
                        a.setMonth(m);
                    }
                    break;
                case "%y":
                    if (!isNaN(D[c_3])) {
                        var C = Number(D[c_3]);
                        a.setFullYear(C + (C > 50 ? 1900 : 2000));
                    }
                    break;
                case "%g":
                case "%h":
                    if (!isNaN(D[c_3])) {
                        var cNumber = Number(D[c_3]);
                        if (cNumber <= 12 && cNumber >= 0) {
                            a.setHours(cNumber +
                                (x("pm", D) >= 0
                                    ? cNumber == 12
                                        ? 0
                                        : 12
                                    : cNumber == 12
                                        ? -12
                                        : 0));
                        }
                    }
                    break;
                case "%P":
                    if (dhx4.temp_calendar != null) {
                        dhx4.temp_calendar.tz = D[c_3];
                    }
                    break;
            }
        }
        return a;
    };
}



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/global/dhx4OrDhx/dhx4.dateLang.js